<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :setLoading="setLoading"
    :localDataGrid="false"
    :backButtonRoute="backButtonRoute"
    ref="stock-transfer"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :serverError="serverError"
    :refreshColumns="refreshColumns"
    class="stock-transfer"
    :headerScreenJson="getHeaderScreenJson"
    :data-model="model"
  />
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { BranchService } from "../../_services/api/sales/branch.service";
import { getFactorByCode } from "../../_store/helpers";
import { mapGetters } from "vuex";
import { alert } from "devextreme/ui/dialog";
// import { ProductService } from "../../_services/api/products/product.service";
import { StockTransferService } from "../../_services/api/inventory/stock-transfer-service";
import { ProductService } from "../../_services/api/products/product.service";

function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}

let batchRecordBase = {
  BatchNo: undefined,
  SupplierName: undefined,
  SupplierCode: undefined,
  UseByDate: undefined,
  AvailableQty: undefined,
  BatchTransferQty: 0,
};

let productEntryBase = {
  ProductCode: undefined,
  ProductDescription1: undefined,
  IsBatchProduct: "No",
  BranchCode: undefined,
  BranchDescription: undefined,
  UnitOfMeasureCode: undefined,
  Onhand: 0,
  TransferQty: 0,
  // AdjustmentQuantity: 0,
  Comment: "",
  LineNo: 0,
  StockEnquiryQuantities: [],
};

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      loaded: false,
      setLoading: false,
      reload: false,
      validationSummary: [],
      serverError: {},
      refreshColumns: undefined,
      ui: {
        DateAdjustedMin: null,
        DateAdjustedMax: null,
      },
      defaultBranchCode: undefined,
      dataModel: {
        DateIn: new Date(),
        DateReceived: new Date(),
        // toFriendlyStatus: "N",
        Status: "N",
      },
      brokenGridValidations: [],

      // Start

      branchDataSourceItems: [],

      model: {
        Status: "N",
        FriendlyStatus: undefined,
        // toFriendlyStatus: "N",
        DateIn: new Date(),
        Code: null,
        // DateIn: null,
        BranchCode: null,
        ToBranchCode: null,
        NextStatus: "C",
        ConsignmentNo: "",
        DeliveryAddressCompanyName: "",
        DeliveryAddressCountry: "",
        DeliveryAddressPostcode: null,
        DeliveryAddressState: "",
        DeliveryAddressStreetLine1: "",
        DeliveryAddressStreetLine2: "",
        DeliveryAddressSuburb: "",
        StockTransferDetails: [],
        // Status: "",
        RequiredByDate: null,
        PartDeliver: "N",
        NoBackorder: "N",
        SalesRepresentativeCode: "",
        DateChanged: "",
        DateCreated: "",
        ChangedBy: "",
        CreatedBy: "",
      },

      productEntryLocalItems: [],
      productDataSourceItems: [],
    };
  },

  async created() {},
  async mounted() {
    this.$store.dispatch("dataContext/setReviewDataSource", []);
    this.initialized();
  },
  beforeDestroy() {},

  computed: {
    ...mapGetters({ dataViewType: "dataContext/getDataViewType" }),
    ...mapGetters({ reviewDataSource: "dataContext/getReviewDataSource" }),
    backButtonRoute() {
      return "/stock-transfer";
    },
    getScreenJson() {
      var screenJson = {
        title: "Stock Adjustment",
        endpoint: {
          primary: this.baseView.mode != "create" ? "StockTransfer" : undefined,
          // expand: "Customer($select=Name)",
          // CodeBy: this.baseView.mode == "review" ? "text" : undefined,
          // postProcess: this.cashReceiptPostProcess,
        },
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: this.baseView.mode == "create" ? "Product" : undefined,
              filter:
                this.baseView.mode == "create"
                  ? [["Inactive", "=", "N"]]
                  : undefined,
              orderby: "Description1",
              serverPaging: true,
              allowGrouping: false,
              // expand: "SaleItem",
              postProcessCallback: this.stockTransferDetailPostProcess,
            },
            options: {
              wordWrapEnabled: true,
              // selectionMode: 'none'
            },
            noDataMessage: {
              // this `review` is one of the options in the grid toolbar dropdown that represents 'Review', 'ProductList' 'CustomerList'
              review: {
                addNew: {
                  class: "add-new",
                  title: "No Transfer Lines",
                  message: "Get Started, Add a Product Line",
                },
              },
              "product-list": {
                addNew: {
                  class: "no-data",
                  title: "No Product Lines",
                  message:
                    "Products must be in the system for them to appear here. Head over to the Product screen to start adding them.",
                },
              },
              addNew: {
                class: "add-new",
                title: "No Transfer Lines",
                message: "Get Started, Add a Product Line",
              },
            },

            dataGridViews:
              // this.baseView.mode != "review"
              //   ?
              [
                {
                  label: "Review",
                  value: "review",
                  default: this.baseView.mode != "create",
                  dataSource: {
                    items: [],
                  },
                  columns: this.getProductEntryColumns,
                },
                {
                  label: "Product List",
                  value: "product-list",
                  default: this.baseView.mode == "create",
                  dataSource: {
                    endpoint: "Product",
                    filter: [["Inactive", "=", "N"]],
                    expand: "StockEnquiryQuantities",
                    serverPaging: true,
                    allowGrouping: false,
                    // orderby: "Description1",
                    postProcessCallback: this.stockTransferDetailPostProcess,
                  },
                  columns: this.getProductEntryColumns,
                },
                {
                  label: "Product Entry",
                  value: "product-entry",
                  default: false,
                  // disabled: true,
                  dataSource: {
                    // endpoint: "Product",
                    filter: [["Inactive", "=", "N"]],
                    serverPaging: true,
                    allowGrouping: false,
                    orderby: "Description1",
                    postProcessCallback: this.productEntryPostProcess,

                    localDataList: true,
                    items: this.productEntryLocalItems,
                  },
                  columns: this.getProductEntryColumns,
                },
              ],
            // : undefined,
          },
          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: this.dataViewType == "product-list",
            expand: true,
            review: true,
            save: false,
            audit: false,

            addNew: this.dataViewType == "product-entry",
            addNewCallBack: this.addNewItemToList,
          },
          childColumns: [
            {
              screenField: "Batch",
              gridDataField: "BatchNo",
              allowEditing: false,
              makeAcceptCustomValue: () => {
                // data, parentline
                // return parentline.data.IsBatchProduct == "Manual";

                return false;
              },
              onCustomItemCreating: this.onCustomItemCreating,
              showEditorAlways: false,
              // cellTemplate: "EditableText",
              cellTemplate:
                this.baseView.mode != "review" ? "SelectField" : false,
              allowUpdate: true,
              customFilter: (data) => {
                let branchCode = undefined;
                if (!this.model.BranchCode)
                  branchCode =
                    this.$refs["stock-transfer"].getTransactionData()
                      .BranchCode;
                else branchCode = this.model.BranchCode;
                return [
                  ["ItemCode", "=", data.data.ItemCode],
                  ["BranchCode", "=", branchCode],
                  ["SourceTransactionType", "=", ""],
                  ["SourceTransactionNo", "=", 0],
                  ["SourceTransactionLine", "=", 0],
                  ["SourceTransactionProcessCode", "=", ""],
                ];
              },
              dataSourceConfig: {
                endpoint: "api/ConsumeProductBatch",
                sort: {
                  selector: "BatchNo",
                  asc: true,
                },
                select: [
                  "BatchNo",
                  "SupplierCode",
                  "SupplierName",
                  "UseByDate",
                  "AvailableQty",
                  "OnHand",
                ],
              },
              editorTemplate: {
                primary: [
                  {
                    dataField: "BatchNo",
                    position: "append",
                  },
                ],
                secondary: [
                  {
                    dataField: "SupplierCode",
                    position: "append",
                  },
                  {
                    dataField: "SupplierName",
                    position: "append",
                  },
                  {
                    dataField: "UseByDate",
                    position: "append",
                  },
                  {
                    dataField: "AvailableQty",
                    position: "append",
                  },
                ],
              },
              // editorOptions: {
              dropDownOptions: {
                minWidth: 275,
              },
              // },

              displayExpr: "BatchNo",
              valueExpr: "BatchNo",
              searchExpr: ["BatchNo"],
              // searchMode: "contains",
            },
            {
              screenField: "ProductSupplier",
              gridDataField: "SupplierCode",
              cellTemplate: "Record",
              // cellTemplate: "EditableText",
              // customFilter: (data) => {
              //   return [["ProductCode", "=", data.data.ItemCode]];
              // },
            },
            {
              screenField: "UseByDate",
              allowEditing: false,
              allowSearch: false,
              allowFiltering: false,
              cellTemplate: "Date",
              editable: false,
              makeReadOnly: () => {
                // if (data.data.BatchNoSelected || this.baseView.mode == "review")
                return true;
                // else return false;
              },
            },

            // {
            //   screenField: "OnHand",
            //   allowSorting: false,
            //   allowSearch: false,
            //   allowFiltering: false,
            //   format: "Decimal-16-2",
            //   visible: this.baseView.mode == "create",
            // },
            // {
            //   screenField: "Quantity",
            //   dataField: "BatchNewQuantity",
            //   label: "New Quantity",
            //   type: "EditableDecimal",
            //   showEditorAlways: true,
            //   format: "Decimal-16-2",
            //   allowEditing: true,
            //   allowSorting: false,
            //   allowSearch: false,
            //   allowFiltering: false,
            //   visible: this.baseView.mode == "create",
            // },
            {
              screenField: "Available",
              dataField: "AvailableQty",
              format: "Decimal-16-2",
              label: "On Hand",
              // visible: this.baseView.mode != "create",
            },
            {
              screenField: "Quantity",
              dataField: "BatchTransferQty",
              label: "Transfer",
              type: "EditableDecimal",
              showEditorAlways: this.baseView.mode != "review",
              format: "Decimal-16-2",
              // allowEditing: true,
              // makeReadOnly: (data) => {
              //   if (data.data.IsBatchProduct != "No") {
              //     return true;
              //   } else return false;
              // },
              allowSorting: false,
              allowSearch: false,
              allowFiltering: false,
            },
            // {
            //   screenField: "Quantity",
            //   dataField:
            //     this.baseView.mode == "review"
            //       ? "AdjustedQty"
            //       : "BatchTransferQty",
            //   type:
            //     this.baseView.mode == "create"
            //       ? "EditableDecimal"
            //       : "EditableDecimal",
            //   showEditorAlways: this.baseView.mode == "create",
            //   allowEditing: true,
            //   format: "Decimal-16-2",
            // },
            {
              dataField: "ActionDelete",
              label: "",
              width: 50,
              minWidth: 50,
              cellTemplate: "ActionDelete",
              visible: this.baseView.mode != "review",
              cssClass: "class-custom-btn",
            },
            {
              dataField: "ActionAddNew",
              label: "",
              width: 50,
              minWidth: 50,
              cellTemplate: "ActionAddNew",
              visible: this.baseView.mode != "review",
              cssClass: "class-custom-btn",
            },
          ],
          columns: this.getProductEntryColumns,

          valueChangedEventListners: [
            {
              dataField: "TransferQty",
              listner: (e, lineData) => {
                // lineData.component.collapseAdaptiveDetailRow();
                // lineData.component.collapseRow(lineData.key);

                lineData.data.TransferQty = e.value;

                this.mergeWithReviewView(
                  lineData.data.TransferQty == 0 ? false : true,
                  lineData.data
                );
              },
            },
            {
              dataField: "BatchNo",
              listner: (e, lineData) => {
                if (e.text) {
                  // Item entered by hand.
                  lineData.data.BatchNoSelected = false;
                  lineData.data.IsNewBatch = true;
                  lineData.data.BatchNo = e.text;
                  lineData.data.SupplierCode = batchRecordBase.SupplierCode;
                  lineData.data.SupplierName = batchRecordBase.SupplierName;
                  lineData.data.AvailableQty = batchRecordBase.AvailableQty;
                  lineData.data.UseByDate = batchRecordBase.UseByDate;
                  // lineData.data.Onhand = batchRecordBase.Onhand;
                } else {
                  lineData.data.BatchNoSelected = true;
                  lineData.data.IsNewBatch = false;
                  lineData.data.BatchNo = e.itemData.BatchNo;
                  lineData.data.SupplierCode = e.itemData.SupplierCode;
                  lineData.data.SupplierName = e.itemData.SupplierName;
                  lineData.data.AvailableQty = e.itemData.AvailableQty;
                  lineData.data.UseByDate = e.itemData.UseByDate
                    ? isValidDate(e.itemData.UseByDate)
                      ? e.itemData.UseByDate
                      : new Date(e.itemData.UseByDate)
                    : undefined;
                  // lineData.data.Onhand = e.itemData.OnHand;
                }

                if (this.dataViewType == "product-entry")
                  this.$refs["stock-transfer"].$refs[
                    "transactionGrid"
                  ].gridRepaint();
              },
            },
            {
              dataField: "UseByDate",
              listner: (e, lineData) => {
                lineData.data.UseByDate = e.value;
              },
            },

            {
              dataField: "Comment",
              listner: (e, lineData) => {
                if (e.value.length >= 1000) {
                  this.addToValidationSum(
                    "comments only allow maximum length of 1000 characters"
                  );
                  lineData.data.Comment = e.previousValue;
                  e.component.beginUpdate();
                  e.component.option("value", e.previousValue);
                  e.component.endUpdate();
                } else lineData.data.Comment = e.value;
                this.mergeWithReviewView(true, lineData.data);
              },
            },

            // Prod Entry Columns

            {
              dataField: "Code",
              listner: (e, lineData) => {
                // lineData.component.collapseAdaptiveDetailRow();
                lineData.component.collapseRow(lineData.key);

                if (!lineData.data.BranchCode)
                  lineData.data.BranchCode = this.model.BranchCode;
                lineData.data.Code = e.itemData.Code;
                lineData.data.IsBatchProduct = e.itemData.IsBatchProduct;
                lineData.data.Description1 = e.itemData.Description1;
                lineData.data.UnitOfMeasureCode = e.itemData.UnitOfMeasureCode;

                lineData.data.ProductCode = e.itemData.Code;
                lineData.data.ProductDescription1 = e.itemData.Description1;
                lineData.data.StockEnquiryQuantities =
                  e.itemData.StockEnquiryQuantities;

                lineData.data.IsProductEntry = true;

                e.itemData.StockEnquiryQuantities.forEach((stockItem) => {
                  if (stockItem.BranchCode == lineData.data.BranchCode) {
                    lineData.data.Onhand = stockItem.OnHand;
                    // lineData.data.NewQuantity = stockItem.OnHand;

                    lineData.data.NewQuantity =
                      lineData.data.Onhand + lineData.data.AdjustmentQuantity;
                  }
                });
                this.stockTransferDetailPostProcess([lineData.data]);

                this.$refs["stock-transfer"].$refs[
                  "transactionGrid"
                ].gridRepaint();
              },
            },

            // {
            //   dataField: "BatchTransferQty",
            //   listner: (e, lineData) => {
            //     lineData.data.BatchTransferQty = e.value;
            //     lineData.data.NewQuantity = e.value + lineData.data.Onhand;

            //     this.mergeWithReviewView(
            //       lineData.data.AdjustmentQuantity == 0 ? false : true,
            //       lineData.data
            //     );
            //   },
            // },
            {
              dataField: "BatchTransferQty",
              listner: (e, lineData, gridItems, grid, lineParent) => {
                if (!e.event) return;
                this.onBatchTransferQtyChange(
                  e,
                  lineData,
                  gridItems,
                  grid,
                  lineParent
                );
              },
            },

            {
              dataField: "ActionDelete",
              listner: (e, lineData, lineParent) => {
                this.onActionDetele(e, lineData, lineParent);
              },
            },
            {
              dataField: "ActionCopy",
              listner: (e, lineData) => {
                this.copyRow(e, lineData);
              },
            },

            {
              dataField: "ActionAddNew",
              listner: (e, lineData, lineParent) => {
                if (e && lineData && lineParent)
                  lineParent.data.ChildDataSource.push({
                    BatchNo: undefined,
                    IsNewBatch: false,
                    SupplierCode: undefined,
                    SupplierName: undefined,
                    UseByDate: undefined,
                    AvailableQty: 0,
                    ItemCode: lineParent.data.Code,
                    BranchCode: lineParent.data.BranchCode,
                    // BatchTransferQty: 0,
                    LineNo: 0,
                    Onhand: 0,
                    BatchTransferQty: 0,
                    // BatchAdjustmentQuantity: 0,
                  });
                else {
                  if (this.dataViewType == "product-entry") {
                    // let dataObj = Object.assign(
                    //   { IsCopyLine: false },
                    //   productEntryBase
                    // );
                    // this.productEntryLocalItems.push({ ...dataObj });
                    this.addNewItemToList();
                  }
                }

                if (this.dataViewType == "product-entry")
                  this.$refs["stock-transfer"].$refs[
                    "transactionGrid"
                  ].gridRepaint();
              },
            },
          ],
        },
        // footerData: {
        //   footerItems: [],
        // },
      };
      return screenJson;
    },
    getHeaderScreenJson() {
      return {
        headerData: {
          headerFormVisible: true,
          headerToolbar: {
            audit: this.baseView.mode == "review",
            status: true,
            notes: false,
            save: this.model.Status !== "C" && this.model.Status !== "X",
            saveOptions: {
              items: this.baseView.id
                ? [
                    { text: "Save Pending", id: "P" },
                    { text: "Save & Commit", id: "C", default: true },
                    { text: "Cancel", id: "X" },
                  ]
                : [
                    { text: "Save Pending", id: "P" },
                    { text: "Save & Commit", id: "C", default: true },
                  ],
              keyExpr: "id",
              displayExpr: "text",
              dropDownOptions: {
                width: "150px",
              },
              saveKey: "NextStatus",
            },
            saveCallback: this.savestockTransfer,
            screenName: "Stock Transfers - All",
            pdf: this.baseView.mode == "review",

            toolbarFormItems: [
              {
                dataField: "DateIn",
                editorType: "dxDateBox",
                label: {
                  text: "Date",
                },
                editorOptions: {
                  displayFormat: "dd MMM yyyy",
                  width: 120,
                  min: this.minDate,
                  max: this.ui.DateAdjustedMax,
                  readOnly: this.baseView.mode == "review",
                },
                // validationRules: [
                //   {
                //     type: "required",
                //     message: "Date Received is required",
                //   },
                // ],
              },
              // },
            ],
            auditItems: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    dataField: "FormattedDateCreated",
                    label: { text: "Created By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {
                      // // disabled: true,
                    },
                  },
                  {
                    dataField: "FormattedDateChanged",
                    label: { text: "Changed By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {
                      // disabled: true,
                    },
                  },
                ],
              },
            ],
          },
          title: {
            // Credit # [CreditNote] for Invoice # [InvoiceNumber]
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: undefined,
                text:
                  this.baseView.mode == "create"
                    ? "Create Stock Transfer"
                    : "Stock Transfer # " + this.baseView.id,
              },
              secondary: {
                dataField: undefined,
                text: undefined,
              },
            },
            secondary: {
              dataField: undefined,
              text: undefined,
            },
          },
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 3,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "Branch",
                      label: {
                        text: "From Branch",
                      },
                      dataField: "BranchCode",
                      required: true,
                      editorOptions: {
                        // onItemClick: this.onBranchCodeValueChanged.bind(this),
                        // placeholder: this.branchPlaceHolder,
                        // elementAttr: {
                        //   class:
                        //     this.branchPlaceHolder != "Select"
                        //       ? "class-multiple"
                        //       : "class-name",
                        // },
                        onValueChanged:
                          this.onFromBranchValueChanged.bind(this),
                      },
                      dataSourceConfig: {
                        data: this.branchDataSourceItems, // .filter(
                        //   (x) =>
                        //     x.ComputedCode != this.newBankTransferModel.FromBank
                        // ),
                      },
                    },
                    {
                      screenField: "ConNote",
                      label: {
                        text: "Consignment",
                      },
                      editorOptions: {
                        // maxLength: 10,
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "Branch",
                      label: {
                        text: "To Branch",
                      },
                      dataField: "ToBranchCode",
                      required: true,
                      editorOptions: {
                        onItemClick: this.onToBranchValueChanged.bind(this),
                        // placeholder: this.branchPlaceHolder,
                        // elementAttr: {
                        //   class:
                        //     this.branchPlaceHolder != "Select"
                        //       ? "class-multiple"
                        //       : "class-name",
                        // },
                      },
                      dataSourceConfig: {
                        data: this.branchDataSourceItems.filter(
                          (x) => x.Code != this.model.BranchCode
                        ),
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      };
    },
    getProductEntryColumns() {
      return [
        this.baseView.mode == "review"
          ? {
              screenField: "ProductItem",
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              label: "Product",
              width: "auto",
              sortOrder: "asc",
              sortIndex: 0,
            }
          : {
              screenField: "Product",
              // allowEditing: true,
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              label: "Product",
              width: "auto",
              sortOrder:
                this.dataViewType != "product-entry" ? "asc" : undefined,
              sortIndex: this.dataViewType != "product-entry" ? 0 : undefined,
              gridDataField:
                this.dataViewType != "product-entry" ? "Description1" : "Code",
              cellTemplateRecord: {
                image: {
                  codeDataField: "Code",
                  descriptionDataField: "Description1",
                  hasPrimaryImageDataField: "HasPrimaryImage",
                },
                primary: [
                  {
                    dataField: "Description1",
                  },
                ],
                secondary: [
                  {
                    dataField: "Code",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "Code",
                  label: "Product Code",
                },
                {
                  dataField: "Description1",
                  label: "Product Description 1",
                },
              ],

              dataSourceConfig: {
                data: this.productDataSourceItems,
              },
              cellTemplate:
                this.dataViewType != "product-entry" ? "Record" : "SelectField",
              valueExpr: "Code",
              displayExpr: "Description1",
            },
        {
          screenField: "SalesUM",
          dataField: "UnitOfMeasureCode",
          minWidth: 75,
          width: "auto",
        },
        {
          screenField: "OnHand",
          allowSorting: false,
          allowSearch: false,
          allowFiltering: false,
          format: "Decimal-16-2",
          visible: this.baseView.mode != "review",
        },
        {
          screenField: "Quantity",
          dataField: "TransferQty",
          label: "Transfer",
          type: "EditableDecimal",
          showEditorAlways: true,
          format: "Decimal-16-2",
          allowEditing: true,
          makeReadOnly: (data) => {
            if (data.data.IsBatchProduct != "No") {
              return true;
            } else return false;
          },
          allowSorting: false,
          allowSearch: false,
          allowFiltering: false,
          minmax: { min: 0, max: 999999999.99 },
        },
        {
          screenField: "Comments",
          dataField: "Comment",
          // allowEditing: this.baseView.mode != "review",
          showEditorAlways: true,
          // allowEditing: true,
          allowSearch: false,
          allowSorting: false,
          minWidth: 250,
          editCellTemplate: "EditableTextArea",
        },
        {
          dataField: "ActionDelete",
          label: "",
          width: 50,
          minWidth: 50,
          cellTemplate: "ActionDelete",
          visible: this.baseView.mode != "review",
          cssClass: "class-custom-btn",
        },
        {
          dataField: "ActionCopy",
          label: "",
          width: 50,
          minWidth: 50,
          cellTemplate: "ActionCopy",
          visible: this.baseView.mode != "review",
          cssClass: "class-custom-btn",
          allowSearch: false,
          allowFiltering: false,
          // makeDisabled: (data) => {
          //   if (!data.data.Code) return true;
          //   else return false;
          // },
        },
        {
          dataField: "ActionAddNew",
          label: "",
          width: 50,
          minWidth: 50,
          cellTemplate: "ActionAddNew",
          visible:
            this.baseView.mode != "review" &&
            this.dataViewType == "product-entry",
          cssClass: "class-custom-btn",
        },

        {
          screenField: "ProductCategory1",
          filterLabel: "Category 1",
          filterIndex: 0,
          showInColumnChooser: false,
          visible: false,
          exportFields: false,
          gridDataField: "ProductCategory1Code",
        },
        {
          screenField: "ProductCategory2",
          filterLabel: "Category 2",
          filterIndex: 1,
          showInColumnChooser: false,
          visible: false,
          exportFields: false,
          gridDataField: "ProductCategory2Code",
        },
        {
          screenField: "ProductCategory3",
          filterLabel: "Category 3",
          filterIndex: 2,
          showInColumnChooser: false,
          visible: false,
          exportFields: false,
          gridDataField: "ProductCategory3Code",
        },
        {
          screenField: "ProductCategory4",
          filterLabel: "Category 4",
          filterIndex: 3,
          showInColumnChooser: false,
          visible: false,
          exportFields: false,
          gridDataField: "ProductCategory4Code",
        },
        {
          screenField: "ProductType",
          gridDataField: "ProductTypeCode",
          filterLabel: "Type",
          filterIndex: 4,
          showInColumnChooser: false,
          visible: false,
          exportFields: false,
        },
        {
          screenField: "ProductSize",
          gridDataField: "ProductSizeCode",
          filterLabel: "Size",
          filterIndex: 5,
          showInColumnChooser: false,
          visible: false,
          exportFields: false,
        },
        {
          screenField: "Product",
          // gridDataField: "ItemCode",
          // filterLabel: "Size",
          filterIndex: 6,
          showInColumnChooser: false,
          visible: false,
          exportFields: false,
          filterDataField: this.baseView.mode == "review" ? "ItemCode" : "Code",
          allowSearch: false,
          allowFiltering: false,
        },
      ];
    },
    getSelectedViewType() {
      if (this.baseView.mode == "review") return "review";
      return this.dataViewType;
    },
    isEditVisible() {
      if (this.baseView.mode == "create") return true;
      else {
        return (
          this.$refs["stock-transfer"].getTransactionData().Status !== "C" &&
          this.$refs["stock-transfer"].getTransactionData().Status !== "X"
        );
      }
    },
  },
  methods: {
    addNewItemToList() {
      if (this.dataViewType == "product-entry") {
        let dataObj = Object.assign({ IsCopyLine: false }, productEntryBase);
        this.productEntryLocalItems.push({ ...dataObj });
      }
    },
    onBatchTransferQtyChange(e, lineData, gridItems, grid, lineParent) {
      lineData.data.BatchTransferQty = e.value;

      lineParent.data.TransferQty =
        lineParent.data.TransferQty -
        (e.previousValue ? e.previousValue : 0) +
        e.value;

      if (e.value > lineData.data.AvailableQty) {
        let errorMsg = {
          Code: lineParent.data.Code,
          Description: lineParent.data.Description1,
          Batch: lineData.data.BatchNo,
          TransferQty: e.value,
          AvailableQty: lineData.data.AvailableQty,
        };
        const index = this.brokenGridValidations.findIndex(
          (x) =>
            x.Code === lineParent.data.Code && x.Batch === lineData.data.BatchNo
        );
        if (index > -1) {
          this.brokenGridValidations[index] = errorMsg;
        } else {
          this.brokenGridValidations.push(errorMsg);
        }
        this.$nextTick(function () {
          alert(
            `Batch ${lineData.data.BatchNo} of item : ${
              lineParent.data.ItemDescription
            } has a transfer quantity of ${this.formatNumber(
              e.value
            )} which is more than the available quantity of ${this.formatNumber(
              lineData.data.AvailableQty
            )}`,
            "Validation Errors"
          );
        });
      } else {
        const index = this.brokenGridValidations.findIndex(
          (x) =>
            x.Code === lineParent.data.Code && x.Batch === lineData.data.BatchNo
        );
        if (index > -1) {
          this.brokenGridValidations.splice(index, 1);
        }
      }

      this.mergeWithReviewView(
        lineParent.data.TransferQty == 0 ? false : true,
        lineParent.data
      );
    },
    onToBranchValueChanged(e) {
      // return;
      // this.$logger.debug("onToBranchValueChanged", e);
      this.model.ToBranchCode = e.itemData.Code;

      this.model.DeliveryAddressCompanyName = e.itemData.Description;
      this.model.DeliveryAddressCountry = e.itemData.MailAddressCountry;
      this.model.DeliveryAddressPostcode = e.itemData.MailAddressPostcode;
      this.model.DeliveryAddressState = e.itemData.MailAddressState;
      this.model.DeliveryAddressStreetLine1 = e.itemData.MailAddressStreetLine1;
      this.model.DeliveryAddressStreetLine2 = e.itemData.MailAddressStreetLine2;
      this.model.DeliveryAddressSuburb = e.itemData.MailAddressSuburb;
    },
    async onFromBranchValueChanged(e) {
      if (!e.event) return;

      let itemWithQtyExists = this.reviewDataSource.find(
        (x) => x.TransferQty > 0
      );

      if (itemWithQtyExists) {
        let confirmFromBranchChange = await this.$confirm(
          `All product transfer information will be lost if the branch is changed. Do you want to continue?`,
          "Stock Transfer"
        );

        if (confirmFromBranchChange) {
          this.$store.dispatch("dataContext/setReviewDataSource", []);
          this.productEntryLocalItems = [productEntryBase];
          this.model.BranchCode = e.value;

          this.$refs["stock-transfer"].$refs["transactionGrid"].gridRepaint();
        } else {
          if (this.baseView.mode != "edit")
            this.model.BranchCode = e.previousValue;
          else {
            e.component.beginUpdate();
            e.component.option("value", e.previousValue);
            e.component.endUpdate();
          }
        }
      } else {
        this.model.BranchCode = e.value;

        this.$refs["stock-transfer"].$refs["transactionGrid"].gridRepaint();
      }
    },
    // TODO(SS): check this code if this code has any affect on Custom Item Creation in the Product batch grid
    onCustomItemCreating(e, lineData, lineParent) {
      if (e && lineData) {
        let record = Object.assign({}, batchRecordBase);
        record.BatchNo = e.text;

        if (lineParent) {
          record.ItemCode = lineParent.data.Code;
          record.BranchCode = lineParent.data.BranchCode;
          lineParent.data.ChildDataSource[lineData.rowIndex] = record;
        }
      }
    },
    addToValidationSum(message) {
      this.validationSummary = [];
      this.validationSummary.push({
        message: message,
      });
    },
    copyRow(e, lineData) {
      lineData.data.CopyTriggered = true;
      let dataObj = Object.assign({ IsCopyLine: true }, lineData.data);
      dataObj.IsCopyLine = true;
      dataObj.LineNo = 0;
      dataObj.CopyTriggered = false;
      // dataObj.TransferQty = 0;

      var data = this.reviewDataSource.filter((x) => x.Code == dataObj.Code);
      dataObj.CopyCode = dataObj.Code + "-" + (data.length + 1);

      if (dataObj.ChildDataSource) {
        dataObj.ChildDataSource = dataObj.ChildDataSource.map((x) =>
          Object.assign({}, x)
        );
      }

      // items.splice(lineData.rowIndex + 1, 0 , dataObj);

      if (this.dataViewType == "product-entry") {
        if (!lineData.data.Code) {
          this.addToValidationSum("Product can not be empty");
          return;
        } else {
          this.productEntryLocalItems.push({ ...dataObj });
        }
      }

      this.addToReview({ ...dataObj });

      this.$refs["stock-transfer"].$refs["transactionGrid"].gridRepaint();
    },
    async savestockTransfer() {
      if (this.baseView.mode != " create")
        this.model = this.$refs["stock-transfer"].getTransactionData();
      if (this.reviewDataSource.length === 0) {
        this.addValidations(
          "Stock Transfer has no detail. Please add one or more lines before attempting to save the transaction again."
        );
        return;
      }

      let payload = this.getSavePayload();

      if (this.brokenGridValidations.length !== 0) {
        let validationMessages = this.brokenGridValidations.map((item) => {
          return {
            message: `Batch ${item.Batch} of item : ${
              item.Description
            } has a transfer quantity of ${this.formatNumber(
              item.TransferQty
            )} which is more than the available quantity of ${this.formatNumber(
              item.AvailableQty
            )}.`,
          };
        });

        this.validationSummary = [];
        this.validationSummary = validationMessages;
        // this.displayValidationSummary(validationMessages);
        return;
      }

      this.setLoading = true;
      await StockTransferService.save(payload, this.model.Code)
        .then((res) => {
          this.setLoading = false;

          if (this.baseView.mode == "create") {
            this.model.Code = res.data.Code;
          }

          this.$notify(
            `Stock Transfer ${this.model.Code} Successfully Saved`,
            "success"
          );

          this.setIgnoreRouteChangeConfirmation();
          this.$router
            .push({
              path: `/stock-transfer/review/${this.model.Code}`,
            })
            .then(() => {
              this.$store.dispatch("dataContext/setDataViewType", "review");

              this.loaded = false;
              this.initialized();
              this.$store.dispatch("dataContext/setReviewDataSource", []);
            });
        })
        .catch((error) => {
          // this.displayServerError(error, "Save stock transfer Failed");
          this.setLoading = false;
          this.serverError = {
            err: error,
            msg: "Save stock transfer Failed",
            time: new Date().getTime(),
          };
        });
    },

    getSavePayload() {
      let payload = {
        Code: this.baseView.id,
        DateIn: new Date(this.model.DateIn).toSaveDate(),
        BranchCode: this.model.BranchCode,
        ToBranchCode: this.model.ToBranchCode,
        NextStatus: this.model.NextStatus == "C" ? "A" : this.model.NextStatus,
        ConsignmentNo: this.model.ConsignmentNo,
        DeliveryAddressCompanyName: this.model.DeliveryAddressCompanyName,
        DeliveryAddressCountry: this.model.DeliveryAddressCountry,
        DeliveryAddressPostcode: this.model.DeliveryAddressPostcode,
        DeliveryAddressState: this.model.DeliveryAddressState,
        DeliveryAddressStreetLine1: this.model.DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2: this.model.DeliveryAddressStreetLine2,
        DeliveryAddressSuburb: this.model.DeliveryAddressSuburb,
        Status: this.model.Status,
        StockTransferDetails: this.getStockTransferDetailPayload(),
      };

      delete payload.Status;
      if (this.baseView.mode == "create") delete payload.Code;
      return payload;
    },

    getStockTransferDetailPayload() {
      let details = [];

      this.reviewDataSource.forEach((data) => {
        let detailObj = {
          TransferQty: data.TransferQty,
          ItemCode: data.ItemCode,
          Comment: data.Comment,
        };
        if (data.IsBatchProduct !== "No") {
          detailObj.StockTransferProductBatches =
            this.getProductBatchDetailsPayload(data.ChildDataSource);
        }
        details.push(detailObj);
      });

      return details;
    },
    getProductBatchDetailsPayload(batches) {
      let batchPayload = [];
      batches.forEach((batch) => {
        let batchObj = {
          TransferQty: batch.BatchTransferQty,
          BatchNo: batch.BatchNo,
          Comment: batch.Comment,
          SupplierCode: batch.SupplierCode,
        };

        if (batch.BatchNo && batch.BatchTransferQty)
          batchPayload.push(batchObj);
      });

      return batchPayload;
    },
    addValidations(message) {
      this.validationSummary = [];
      this.validationSummary.push({
        message: message,
      });
    },
    formatNumber(number) {
      return Number(parseFloat(number).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2,
      });
    },
    addToReview(item) {
      this.reviewDataSource.push(item);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource
      );
    },
    async removeFromReview(index) {
      this.reviewDataSource.splice(index, 1);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource
      );
    },
    mergeWithReviewView(value, item) {
      var index = this.reviewDataSource.findIndex(
        (x) => x.Code == item.Code && x.CopyCode == item.CopyCode
      );

      if (!value) {
        if (index != -1) {
          this.removeFromReview(index);
        }
      } else {
        if (index != -1) {
          this.removeFromReview(index);
        }
        this.addToReview(item);
        // this.setLineNo();
      }
    },
    detailsViewChanged(e) {
      this.$store.dispatch("dataContext/setDataViewType", e.value);
    },
    async onActionDetele(e, lineData, lineParent) {
      let confirmDelete = await this.$confirm(
        "Are you sure you want to delete this record?",
        "Delete"
      );

      if (confirmDelete && e) {
        if (lineParent) {
          lineParent.data.TransferQty -= lineData.data.BatchTransferQty;
          // lineParent.data.AdjustmentQuantity -=
          //   lineData.data.BatchAdjustmentQuantity;

          // lineParent.data.FXAmount =
          //   lineParent.data.FXPrice * lineParent.data.SupplierReceivedQty;
          lineParent.data.ChildDataSource.splice(lineData.rowIndex, 1);
          if (lineParent.data.ChildDataSource.length == 0) {
            lineParent.data.ChildDataSource.push({
              BatchNo: undefined,
              SupplierCode: undefined,
              SupplierName: undefined,
              UseByDate: undefined,
              AvailableQty: 0,
              ItemCode: lineParent.data.Code,
              BranchCode: lineParent.data.BranchCode,
              // BatchTransferQty: 0,
              LineNo: 0,
              Onhand: 0,
              BatchTransferQty: 0,
              // BatchAdjustmentQuantity: 0,
            });
          }

          if (this.dataViewType == "product-entry")
            this.$refs["stock-transfer"].$refs["transactionGrid"].gridRepaint();
        } else {
          let index = undefined;

          if (lineData.data.IsCopyLine) {
            index = this.reviewDataSource.findIndex(
              (x) => x.CopyCode == lineData.data.CopyCode
            );
          } else
            index = this.reviewDataSource.findIndex(
              (x) => x.ItemCode == lineData.data.ItemCode
            );

          if (index != -1) {
            this.removeFromReview(index);
            this.$refs["stock-transfer"].$refs["transactionGrid"].gridRepaint();
          }

          if (
            this.dataViewType == "product-entry" ||
            lineData.data.IsProductEntry == true
          ) {
            let id = this.productEntryLocalItems.findIndex(
              (x) => x.CopyCode == lineData.data.CopyCode
            );
            await this.removeFromProductEntry(id);
          }
        }
      }
    },
    async removeFromProductEntry(index) {
      this.productEntryLocalItems.splice(index, 1);

      if (this.productEntryLocalItems.length === 0) {
        this.productEntryLocalItems = [productEntryBase];
      }
    },
    async setActiveAccountingPeriod() {
      let startDateResult =
        await StockTransferService.getActiveAccountingPeriodStartDate();
      if (startDateResult) {
        let accountingPeriod = startDateResult.data.value[0];
        this.ui.DateAdjustedMin = new Date(accountingPeriod.StartDate);
      }

      let endDateResult =
        await StockTransferService.getActiveAccountingPeriodEndDate();
      if (endDateResult) {
        let accountingPeriod = endDateResult.data.value[0];
        this.ui.DateAdjustedMax = new Date(accountingPeriod.EndDate);
      }
    },
    stockTransferDetailPostProcess(data) {
      var items = [];
      let branchCode = undefined;
      if (!this.model.BranchCode)
        branchCode =
          this.$refs["stock-transfer"].getTransactionData().BranchCode;
      else branchCode = this.model.BranchCode;

      data.forEach((element) => {
        if (!element.CopyCode && element.Code != undefined) {
          element.CopyCode = element.Code + "-0";
        }
        if (element.IsCopyLine == undefined) element.IsCopyLine = false;

        if (this.baseView.mode != "review") {
          element["ItemCode"] = element["Code"];
          element["ItemDescription"] = element["Description1"];

          if (!element["TransferQty"]) element["TransferQty"] = 0;
          if (element.IsBatchProduct != "No") {
            element["ChildDataSource"] = [
              {
                BatchNo: undefined,
                SupplierName: undefined,
                SupplierCode: undefined,
                UseByDate: undefined,
                AvailableQty: undefined,
                BatchTransferQty: 0,
                ItemCode: element.ItemCode,
              },
            ];
          }

          if (!element.Comment) element.Comment = "";
          if (!element.Onhand) element.Onhand = 0;

          var index = this.reviewDataSource.findIndex(
            (i) => i.Code == element.Code && !i.IsCopyLine
          );

          if (index != -1) {
            this.reviewDataSource[index].StockEnquiryQuantities =
              element.StockEnquiryQuantities;
            element = this.reviewDataSource[index];
          }

          element.StockEnquiryQuantities.forEach((stockItem) => {
            if (stockItem.BranchCode == branchCode) {
              element.Onhand = stockItem.OnHand;
            }
          });
          items.push(element);

          var reviewedItems = this.reviewDataSource.filter(
            (a) => a.Code == element.Code && a.IsCopyLine
          );
          if (reviewedItems.length > 0) {
            reviewedItems.forEach((x) => {
              x.StockEnquiryQuantities.forEach((stockItem) => {
                if (stockItem.BranchCode == branchCode) {
                  x.Onhand = stockItem.OnHand;
                }
              });
              items.push(x);
            });
          }
        } else items.push(element);
      });
      return items;
    },
    productEntryPostProcess(data) {
      // var items = [];
      // data.forEach((element) => {
      //   var reviewedItems = this.reviewDataSource.filter(
      //     (a) => a.Code == element.Code && a.IsCopyLine
      //   );

      //   if (reviewedItems.length > 0) {
      //     reviewedItems.forEach((x) => {
      //       // x.StockEnquiryQuantities.forEach((stockItem) => {
      //       //   if (stockItem.BranchCode == branchCode) {
      //       //     x.Onhand = stockItem.OnHand;
      //       //   }
      //       // });
      //       items.push(x);
      //     });
      //   } else items.push(element);
      // });

      let branchCode = undefined;
      if (!this.model.BranchCode)
        branchCode =
          this.$refs["stock-transfer"].getTransactionData().BranchCode;
      else branchCode = { ...this.model.BranchCode };

      this.reviewDataSource.forEach((element) => {
        if (!element.StockEnquiryQuantities) {
          var i = this.productDataSourceItems.findIndex(
            (x) => x.Code == element.Code
          );
          if (i != -1) {
            element.StockEnquiryQuantities =
              this.productDataSourceItems[i].StockEnquiryQuantities;

            element.StockEnquiryQuantities.forEach((stockItem) => {
              if (stockItem.BranchCode == branchCode) {
                element.Onhand = stockItem.OnHand;
              }
            });
          }
        }
        var index = data.findIndex((x) => x.Code == element.Code);
        if (index == -1) data.push(element);
        else {
          var x = data.findIndex((x) => x.CopyCode == element.CopyCode);
          if (x == -1) data.push(element);
        }
      });

      if (data.length == 0) data.push({ ...productEntryBase });
      return data;
    },
    async initialized() {
      // await this.setActiveAccountingPeriod();

      await this.setProductDataSourceItems();
      await this.setBranchDataSourceItems();
      if (this.baseView.mode == "create") {
        await this.$store.dispatch("screenFactors/getFactors", [65]);
        this.defaultBranchCode = getFactorByCode(65).Factorc;

        this.model.BranchCode = getFactorByCode(65).Factorc;
        this.reload = false;
        this.loaded = true;
        this.setLoading = false;
      } else {
        this.$store.dispatch("dataContext/setDataViewType", "review");
        let record = await StockTransferService.getStockTransferDetailsByCode(
          this.baseView.id
        );
        if (record && record.data.value.length > 0) {
          var data = record.data.value;
          await data.forEach(async (element) => {
            this.model.Status = element.LineStatus;
            element.Description1 = element.ItemDescription;
            element.Code = element.ItemCode;
            if (element["IsBatchProduct"] != "No") {
              // eslint-disable-next-line no-debugger
              // debugger;
              await StockTransferService.getProductBatches(
                element["ItemCode"],
                element["LineNo"],
                element["StockTransferCode"]
              ).then((response) => {
                element["ChildDataSource"] = response.data.value;
                element["ChildDataSource"].forEach((item) => {
                  item.BatchTransferQty = item.TransferQty;
                });
              });
              this.addToReview(element);
            } else {
              this.addToReview(element);
            }
          });
        }
        this.reload = false;
        this.loaded = true;
        this.setLoading = false;
      }
      // this.loaded = true;
    },
    async setBranchDataSourceItems() {
      let branchDS = BranchService.dataSourceConfig("api/Branch", {
        filter: [["Inactive", "=", "N"]],
        sort: [{ selector: "Code", asc: true }],
        preventPagination: true,
      });

      this.branchDataSourceItems = await branchDS.load();
    },

    async setProductDataSourceItems() {
      let branchDS = ProductService.dataSourceConfig("api/Product", {
        filter: [["Inactive", "=", "N"], "and", ["Status", "=", "A"]],
        expand: "StockEnquiryQuantities",
        sort: [{ selector: "Description1", asc: true }],
        preventPagination: true,
      });

      this.productDataSourceItems = await branchDS.load();
    },
  },
};
</script>

<style lang="scss">
.stock-transfer {
  .dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td {
    vertical-align: middle !important;
  }
}
</style>
